import { render } from "./ServerNotificationHandler.vue?vue&type=template&id=e7469f58"
import script from "./ServerNotificationHandler.vue?vue&type=script&lang=js"
export * from "./ServerNotificationHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__